import { gql } from '@apollo/client';

export const REMOVE_VEHICLE_FROM_INCIDENT = gql`
mutation removeVehicleFromIncident($input: RemoveVehicleFromIncidentInput!) {
  removeVehicleFromIncident(input: $input) {
    __typename
    clientMutationId
    errors
    vehicleIncidentSpecificUuid
  }
}
`
